import React from 'react';
import PropTypes from 'prop-types';

import {Box, useTheme} from '@spothero/ui';

import NoEvents from './NoEvents';
import EventListItem from './EventListItem';
import {eventListStyleProps} from './EventListStyleProps';

const EventList = ({
    events,
    trackingLink,
    destinationId,
    openNewTabOnClick,
}) => {
    const {
        partnerWidgetStyles: {eventListStyles: customEventListStyles},
    } = useTheme();

    return (
        <Box {...customEventListStyles.eventListContainer}>
            {!events?.length ||
            events.some(event => !Object.keys(event).length) ? (
                <NoEvents
                    destinationId={destinationId}
                    trackingLink={trackingLink}
                />
            ) : (
                <Box
                    {...eventListStyleProps}
                    {...customEventListStyles.eventList}
                >
                    {events.map((event, i) => {
                        return (
                            <EventListItem
                                key={i}
                                event={event}
                                trackingLink={trackingLink}
                                openNewTabOnClick={openNewTabOnClick}
                            />
                        );
                    })}
                </Box>
            )}
        </Box>
    );
};

EventList.propTypes = {
    events: PropTypes.array,
    trackingLink: PropTypes.string,
    destinationId: PropTypes.number,
    openNewTabOnClick: PropTypes.bool,
};

export default EventList;
